import React from "react";

import { Layout, Icon } from "./styles";

import { ZigAlertMessageProps } from "./types";

import ErrorAlertIcon from "@ui/assets/icons/error-alert-icon.svg";
import ZigTypography from "../ZigTypography";
import { useTheme } from "@mui/material";

function ZigAlertMessage({
  text,
  error,
  warning,
  id,
  sx,
  variant = "body2",
  size = "medium",
}: ZigAlertMessageProps) {
  const { palette } = useTheme();
  return (
    <Layout id={id} className={"form-validation-error"} sx={sx}>
      <Icon>
        <ErrorAlertIcon
          height={size === "small" ? "16px" : "24px"}
          width={size === "small" ? "16px" : "24px"}
          color={error ? palette.red : warning ? palette.yellow : palette.neutral400}
        />
      </Icon>
      <ZigTypography
        variant={variant}
        fontSize={size === "small" ? "11px" : undefined}
        sx={{
          color: error ? palette.red : warning ? palette.yellow : palette.neutral400,
        }}
      >
        {text}
      </ZigTypography>
    </Layout>
  );
}

export default ZigAlertMessage;

// added for backwards compatibility
export const ErrorMessage: React.FC<
  Pick<ZigAlertMessageProps, "text" | "id" | "variant" | "size" | "sx">
> = ({ text, id, variant = "body2", size = "medium", sx = {} }) => (
  <ZigAlertMessage size={size} text={text} error id={id} variant={variant} sx={sx} />
);
